import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/kopitar/pripust/preiskava";

export const createPripustnaPreiskava = createAsyncThunk(
  "pripustnaPreiskava/create",
  async (pripustnaPreiskava, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, pripustnaPreiskava);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updatePripustnaPreiskava = createAsyncThunk(
  "pripustnaPreiskava/update",
  async ({ id, pripustnaPreiskava }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(
        `${baseUrl}/${id}`,
        pripustnaPreiskava
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deletePripustnaPreiskava = createAsyncThunk(
  "pripustnaPreiskava/delete",
  async ({ id, version }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.delete(`${baseUrl}/${id}`, { version });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getPripustnaPreiskavaById = createAsyncThunk(
  "pripustnaPreiskava/get",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getPripustnaPreiskavaPage = createAsyncThunk(
  "pripustnaPreiskava/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const pripustnaPreiskavaSlice = createSlice({
  name: "pripustnaPreiskava",
  initialState: {
    content: null,
    page: {},
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    clearPripustnaPreiskavaDetails: (state) => {
      state.content = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPripustnaPreiskava.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPripustnaPreiskava.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
      })
      .addCase(createPripustnaPreiskava.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updatePripustnaPreiskava.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePripustnaPreiskava.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
      })
      .addCase(updatePripustnaPreiskava.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPripustnaPreiskavaById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPripustnaPreiskavaById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
        state.byId[action.payload.id] = action.payload;
      })
      .addCase(getPripustnaPreiskavaById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPripustnaPreiskavaPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPripustnaPreiskavaPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getPripustnaPreiskavaPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deletePripustnaPreiskava.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deletePripustnaPreiskava.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deletePripustnaPreiskava.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPripustnaPreiskavaDetails } =
  pripustnaPreiskavaSlice.actions;
export default pripustnaPreiskavaSlice.reducer;